var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsIgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_48_40843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6328 35.1602C27.2978 35.1602 35.1328 27.3251 35.1328 17.6602C35.1328 7.99517 27.2978 0.160156 17.6328 0.160156C7.96783 0.160156 0.132812 7.99517 0.132812 17.6602C0.132812 27.3251 7.96783 35.1602 17.6328 35.1602Z",
    fill: "url(#paint0_radial_48_40843)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.6294 8.20996H13.6378C10.6263 8.20996 8.18359 10.6527 8.18359 13.6641V21.6558C8.18359 24.6745 10.6263 27.11 13.6378 27.11H21.6294C24.6409 27.11 27.0836 24.6673 27.0836 21.6558V13.6641C27.0836 10.6527 24.6409 8.20996 21.6294 8.20996Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.6339 12.8037C14.9214 12.8037 12.7266 14.9985 12.7266 17.711C12.7266 20.4235 14.9214 22.6183 17.6339 22.6183C20.3464 22.6183 22.5411 20.4235 22.5411 17.711C22.5411 14.9985 20.3464 12.8037 17.6339 12.8037ZM17.6339 20.8829C15.8766 20.8829 14.4547 19.461 14.4547 17.7037C14.4547 15.9464 15.8766 14.5245 17.6339 14.5245C19.3911 14.5245 20.813 15.9464 20.813 17.7037C20.813 19.461 19.3911 20.8829 17.6339 20.8829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.7014 11.4766C22.0744 11.4766 21.5566 11.987 21.5566 12.6214C21.5566 13.2557 22.0671 13.7661 22.7014 13.7661C23.3358 13.7661 23.8462 13.2557 23.8462 12.6214C23.8462 11.987 23.3358 11.4766 22.7014 11.4766Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_48_40843",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.45365 32.7174) scale(35.9844)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFD879"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FCCB75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F4AA6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E8745D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E45F58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#D22A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6968DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_40843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(0.132812 0.160156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsIgCircle);
export default __webpack_public_path__ + "static/media/sns_ig_circle.3976ae4b9efbd30ed854c0f41e17c76f.svg";
export { ForwardRef as ReactComponent };